import React from 'react';
import ComponentForbidden from 'src/components/ComponentForbidden';
import Page from 'src/components/Page';
import { Link as RouterLink } from 'react-router-dom';
import { Button, Stack } from '@mui/material';

const Page403 = () => {
  return (
    <Page title="403 Forbidden">
      <Stack justifyContent="center" alignItems="center" spacing={2}>
        <ComponentForbidden />
        <Button to="/" size="large" variant="contained" component={RouterLink}>
          Home
        </Button>
      </Stack>
    </Page>
  );
};

export default Page403;
